// extracted by mini-css-extract-plugin
export default {"userFollowNftsTitle":"z7Du2EGejanRippkeBs9"};